.body {
  box-sizing: border-box;
  display: flex;
  gap: var(--pgm-sys-spacing-6);
  justify-content: center;
  margin: 0 auto;
  max-width: 1600px;
  padding: var(--pgm-sys-spacing-6) var(--pgm-sys-spacing-6) var(--pgm-sys-spacing-16);
  width: 100%;
}

.main {
  background-color: var(--pgm-sys-color-surface-container-low);
  border-radius: 20px;
  box-sizing: border-box;
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-10);
  min-width: 0;
  padding: var(--pgm-sys-spacing-10);
}

.header {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-3);
}

.title,
.lead,
.meta {
  color: var(--pgm-sys-color-on-surface);
  margin: 0;
}

.image {
  background-color: var(--pgm-sys-color-surface-container-high);
  border-radius: 16px 16px 8px 8px;
  display: block;
  max-width: 754px;
  object-fit: cover;
  width: 100%;
}

.content {
  color: var(--pgm-sys-color-on-surface);
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-6);
}

.content p {
  margin: 0;
}

.content ul {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-2);
  margin: 0;
  padding-left: var(--pgm-sys-spacing-6);
}

.content img {
  border-radius: 16px;
  display: block;
  height: auto;
  max-width: 100%;
}

.aside {
  display: flex;
  flex-direction: column;
  flex: 0 0 360px;
  gap: var(--pgm-sys-spacing-6);
}

.asideHeader {
  border-bottom: 1px solid var(--pgm-sys-color-outline-variant);
  padding: var(--pgm-sys-spacing-2) 0;
}

.asideTitle {
  color: var(--pgm-sys-color-primary);
  margin: 0;
}

.asideList {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-6);
}

@media (max-width: 1024px) {
  .body {
    flex-direction: column;
  }

  .aside {
    flex: 1 1 auto;
  }

  .asideList {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 599.98px) {
  .body {
    padding: var(--pgm-sys-spacing-4) var(--pgm-sys-spacing-4) var(--pgm-sys-spacing-12);
  }

  .main {
    gap: var(--pgm-sys-spacing-6);
    padding: var(--pgm-sys-spacing-4);
  }

  .asideList {
    grid-template-columns: minmax(0, 1fr);
  }
}
